var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805H5.99609C5.46566 1.99805 4.95695 2.20876 4.58188 2.58383C4.20681 2.95891 3.99609 3.46761 3.99609 3.99805V19.998C3.99609 20.5285 4.20681 21.0372 4.58188 21.4123C4.95695 21.7873 5.46566 21.998 5.99609 21.998H17.9961C18.5265 21.998 19.0352 21.7873 19.4103 21.4123C19.7854 21.0372 19.9961 20.5285 19.9961 19.998V8.99805L12.9961 1.99805Z",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805V8.99805H19.9961",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#7755FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.956 22L7.068 15.52H8.604L9.316 19.288L10.084 15.52H11.564L11.676 22H10.66L10.54 17.688L9.788 22H8.884L8.084 17.656L7.988 22H6.956ZM13.0928 22V15.52H14.7328C15.2981 15.52 15.7381 15.592 16.0528 15.736C16.3675 15.8747 16.5888 16.096 16.7168 16.4C16.8448 16.6987 16.9088 17.088 16.9088 17.568V19.92C16.9088 20.4053 16.8448 20.8027 16.7168 21.112C16.5888 21.416 16.3675 21.64 16.0528 21.784C15.7435 21.928 15.3088 22 14.7488 22H13.0928ZM14.5248 21.008H14.7488C14.9675 21.008 15.1248 20.976 15.2208 20.912C15.3168 20.848 15.3755 20.752 15.3968 20.624C15.4235 20.496 15.4368 20.336 15.4368 20.144V17.32C15.4368 17.128 15.4208 16.9733 15.3888 16.856C15.3621 16.7387 15.3008 16.6533 15.2048 16.6C15.1088 16.5467 14.9541 16.52 14.7408 16.52H14.5248V21.008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/md.d4b7237497d40cc006405dc16ce35a8e.svg";
export { ForwardRef as ReactComponent };